export enum LinkColor {
  INHERIT = 'inherit',
  LIGHT = 'light',
  MID = 'mid',
  DARK = 'dark',
  DEFAULT = 'default',
  PRIMARY = 'primary',
  FOREGROUND = 'foreground',
}

export enum LinkHoverColor {
  INHERIT = 'inherit',
  LIGHT = 'light',
  DEFAULT = 'default',
  PRIMARY = 'primary',
  FOREGROUND = 'foreground',
}

export enum LinkUnderline {
  ALWAYS = 'always',
  NEVER = 'never',
  HOVER = 'hover',
}

export enum LinkWeight {
  INHERIT = 'inherit',
  BOLD = 'bold',
  MEDIUM = 'medium',
}

export enum LinkIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface QueryParams {
  [k: string]: any;
}

export enum QueryParamsHandling {
  MERGE = 'merge',
  PRESERVE = 'preserve',
  NONE = '',
}

export enum LinkType {
  MAIL = 'mail',
  TEL = 'tel',
  EXTERNAL = 'external',
  INTERNAL = 'internal',
}

export enum LinkOutline {
  INHERIT = 'inherit',
}

export enum LinkIconGap {
  XXXSMALL = 'xxxsmall',
  XXSMALL = 'xxsmall',
}

/**
 * Icons used with fl-link (font icons).
 */
export type LinkIconName =
  | 'ui-add-circle'
  | 'ui-arrow-back'
  | 'ui-arrow-forward'
  | 'ui-arrow-left'
  | 'ui-arrow-right'
  | 'ui-chevron-down'
  | 'ui-download'
  | 'ui-edit'
  | 'ui-exit'
  | 'ui-file'
  | 'ui-mail'
  | 'ui-open-external'
  | 'ui-phone'
  | 'ui-link-v2'
  | 'ui-bin'
  | 'ui-person'
  | 'ui-folder-check'
  | 'ui-group-outline'
  | 'ui-heart'
  | 'ui-plus';
